export const generatedEconomicsEvidenceLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-economics-evidence-ledger",
  "operatingRule": "Economics inputs require dated source records, model-ready normalization, uncertainty notes, and calibration artifacts before price, ROI, demand, or investment claims can promote.",
  "recordCount": 5,
  "blockedRecordCount": 5,
  "promotionAllowed": false,
  "evidenceHashes": {
    "economicsFrontier": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
    "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
    "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
    "assumptionImpactLedger": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
    "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780"
  },
  "modelContext": {
    "frontierMode": "deterministic-seeded-economics-frontier",
    "frontierPromotionAllowed": false,
    "inputDistributions": {
      "mode": "seeded-planning-heuristic-not-price-forecast",
      "base": {
        "horizonYears": 18,
        "capitalUsdBn": 280,
        "launchMassT": 160,
        "planningLaunchCostUsdPerKg": 1500
      },
      "ranges": {
        "horizonYears": [
          10,
          26
        ],
        "capitalUsdBn": [
          60,
          420
        ],
        "launchMassT": [
          70,
          340
        ],
        "planningLaunchCostUsdPerKg": [
          750,
          3600
        ]
      },
      "units": {
        "horizonYears": "years",
        "capitalUsdBn": "USD billions",
        "launchMassT": "metric tonnes",
        "planningLaunchCostUsdPerKg": "USD/kg"
      },
      "caveat": "Ranges are internal planning bands until dated launch-cost, capex, opex, and market-source records are attached."
    },
    "promotionBlockers": [
      "Launch-cost ranges are internal planning bands until dated source records are attached.",
      "Capex, opex, and demand assumptions are not yet source-backed.",
      "No runtime trajectory/logistics sidecar has promoted mission feasibility claims."
    ]
  },
  "linkedAssumptions": [
    {
      "id": "assumption-no-mercury-first",
      "title": "Mercury cannot be hardcoded as the winning scenario",
      "state": "validated-product-rule",
      "uncertainty": "Low",
      "testGate": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury.",
      "impact": {
        "assumptionId": "assumption-no-mercury-first",
        "title": "Mercury cannot be hardcoded as the winning scenario",
        "state": "validated-product-rule",
        "owner": "Scenario engine",
        "uncertainty": "Low",
        "businessQuestion": "Can conservative transport, thermal, communications, and maturity assumptions make Moon-first win?",
        "affectedScenarioIds": [
          "hybrid",
          "moon-first",
          "mercury-orbit",
          "mercury-polar"
        ],
        "stressWeights": {
          "risks": {
            "transport": 1.22,
            "thermal": 1.18,
            "comms": 1.15,
            "processMaturity": 1.1
          }
        },
        "sourceCoverage": {
          "sourceCount": 3,
          "missingSourceIds": [],
          "primarySourceCount": 3,
          "recordHashes": [
            "fnv1a32-9335c241",
            "fnv1a32-7c477cc2",
            "fnv1a32-78229f8d"
          ]
        },
        "scenarioImpacts": [
          {
            "scenarioId": "hybrid",
            "name": "Hybrid Moon -> Asteroid -> Mercury",
            "baseRank": 2,
            "stressedRank": 2,
            "rankDelta": 0,
            "baseUtility": 65.69,
            "stressedUtility": 65.85,
            "utilityDelta": 0.16
          },
          {
            "scenarioId": "moon-first",
            "name": "Moon-first Bootstrap",
            "baseRank": 1,
            "stressedRank": 1,
            "rankDelta": 0,
            "baseUtility": 67.12,
            "stressedUtility": 67.32,
            "utilityDelta": 0.2
          },
          {
            "scenarioId": "mercury-orbit",
            "name": "Mercury Orbit-first",
            "baseRank": 4,
            "stressedRank": 4,
            "rankDelta": 0,
            "baseUtility": 42.95,
            "stressedUtility": 42.67,
            "utilityDelta": -0.28
          },
          {
            "scenarioId": "mercury-polar",
            "name": "Mercury Polar Surface-first",
            "baseRank": 6,
            "stressedRank": 6,
            "rankDelta": 0,
            "baseUtility": 37.95,
            "stressedUtility": 37.5,
            "utilityDelta": -0.45
          }
        ],
        "maxRankShift": 0,
        "maxUtilityDelta": 0.45,
        "stressedWinner": {
          "scenarioId": "moon-first",
          "name": "Moon-first Bootstrap",
          "utility": 67.32
        },
        "stressedUncertainty": {
          "iterations": 128,
          "seed": "assumption-no-mercury-first-stress",
          "winner": "moon-first",
          "highestWinProbability": 76.56
        },
        "reviewGate": {
          "promotionAllowed": true,
          "state": "reviewable",
          "requiredEvidence": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury.",
          "riskIfWrong": "The product becomes advocacy rather than feasibility intelligence."
        },
        "impactHash": "sha256-af29cde19803c251fdb159311a364c052dcab8378ad33efccbe4fa6641075228"
      }
    },
    {
      "id": "assumption-launch-cost-ranges",
      "title": "Launch economics must use dated ranges and sensitivity bands",
      "state": "hypothesis",
      "uncertainty": "High",
      "testGate": "Every economics run needs source date, mass class, destination, margin, and sensitivity.",
      "impact": {
        "assumptionId": "assumption-launch-cost-ranges",
        "title": "Launch economics must use dated ranges and sensitivity bands",
        "state": "hypothesis",
        "owner": "Economics module",
        "uncertainty": "High",
        "businessQuestion": "Which scenario rankings are most sensitive to dated launch-cost and mass-to-site assumptions?",
        "affectedScenarioIds": [
          "hybrid",
          "moon-first",
          "asteroid-first",
          "mercury-orbit",
          "mercury-polar",
          "mars-first"
        ],
        "stressWeights": {
          "benefits": {
            "resourceConfidence": 1.08
          },
          "risks": {
            "transport": 1.35,
            "processMaturity": 1.08
          }
        },
        "sourceCoverage": {
          "sourceCount": 0,
          "missingSourceIds": [],
          "primarySourceCount": 0,
          "recordHashes": []
        },
        "scenarioImpacts": [
          {
            "scenarioId": "hybrid",
            "name": "Hybrid Moon -> Asteroid -> Mercury",
            "baseRank": 2,
            "stressedRank": 2,
            "rankDelta": 0,
            "baseUtility": 65.69,
            "stressedUtility": 65.62,
            "utilityDelta": -0.07
          },
          {
            "scenarioId": "moon-first",
            "name": "Moon-first Bootstrap",
            "baseRank": 1,
            "stressedRank": 1,
            "rankDelta": 0,
            "baseUtility": 67.12,
            "stressedUtility": 67.56,
            "utilityDelta": 0.44
          },
          {
            "scenarioId": "asteroid-first",
            "name": "Asteroid Feedstock-first",
            "baseRank": 3,
            "stressedRank": 3,
            "rankDelta": 0,
            "baseUtility": 51.37,
            "stressedUtility": 50.98,
            "utilityDelta": -0.39
          },
          {
            "scenarioId": "mercury-orbit",
            "name": "Mercury Orbit-first",
            "baseRank": 4,
            "stressedRank": 4,
            "rankDelta": 0,
            "baseUtility": 42.95,
            "stressedUtility": 42.28,
            "utilityDelta": -0.67
          },
          {
            "scenarioId": "mercury-polar",
            "name": "Mercury Polar Surface-first",
            "baseRank": 6,
            "stressedRank": 6,
            "rankDelta": 0,
            "baseUtility": 37.95,
            "stressedUtility": 37.32,
            "utilityDelta": -0.63
          },
          {
            "scenarioId": "mars-first",
            "name": "Mars-first Conventional Expansion",
            "baseRank": 5,
            "stressedRank": 5,
            "rankDelta": 0,
            "baseUtility": 40.78,
            "stressedUtility": 40.73,
            "utilityDelta": -0.05
          }
        ],
        "maxRankShift": 0,
        "maxUtilityDelta": 0.67,
        "stressedWinner": {
          "scenarioId": "moon-first",
          "name": "Moon-first Bootstrap",
          "utility": 67.56
        },
        "stressedUncertainty": {
          "iterations": 128,
          "seed": "assumption-launch-cost-ranges-stress",
          "winner": "moon-first",
          "highestWinProbability": 79.69
        },
        "reviewGate": {
          "promotionAllowed": false,
          "state": "blocked-for-business-proof",
          "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity.",
          "riskIfWrong": "Scenario rankings could swing materially on stale or optimistic transport costs."
        },
        "impactHash": "sha256-4f535d33727617984ce47c8117d7e5b03da271ddd6a54e14c07b7a083a7675b3"
      }
    }
  ],
  "records": [
    {
      "id": "launch-list-price-source",
      "label": "Launch list-price source intake",
      "inputCategory": "launch-cost",
      "currentUse": "Bounds planningLaunchCostUsdPerKg only after price table capture and orbit normalization.",
      "dataState": "source-linked-not-normalized",
      "sourceDate": "2026-06-20",
      "unitsRequired": [
        "USD",
        "kg",
        "orbit class",
        "payload class"
      ],
      "requiredNormalization": [
        "Extract published price table with access timestamp.",
        "Normalize to USD/kg only for the stated payload/orbit class.",
        "Record mission-specific integration, insurance, rideshare constraints, and schedule caveats."
      ],
      "modelInputRefs": [
        "inputDistributions.ranges.planningLaunchCostUsdPerKg"
      ],
      "sourceRefs": [
        {
          "sourceId": "spacex-rideshare",
          "title": "SpaceX Rideshare Program",
          "trust": "commercial-primary",
          "sourceType": "commercial-launch-pricing",
          "recordHash": "fnv1a32-86aacff8",
          "url": "https://www.spacex.com/rideshare/",
          "queryPolicy": "Capture provider page, access timestamp, price table text, destination/orbit class, and terms caveats before use.",
          "uncertaintyMode": "Commercial list price caveats, mission-specific integration costs, schedule, destination, and contract terms."
        }
      ],
      "missingSourceIds": [],
      "evidenceScore": 66,
      "promotionGate": {
        "promotionAllowed": false,
        "state": "blocked-for-commercial-economics",
        "blockers": [
          "Source data is not normalized into model-ready numeric inputs.",
          "No calibrated capex/opex/market model artifact is attached.",
          "Economics source record is not yet allowed to promote price, ROI, demand, or investment claims."
        ],
        "allowedUse": "May be used only as a source-backed planning boundary, not as a commercial economics claim."
      },
      "evidenceHash": "sha256-dc2d39008cb499d8ecb84fcf7869779f2a12785e52c821d9af3ffc96d5713668"
    },
    {
      "id": "lunar-delivery-contract-envelope",
      "label": "Commercial lunar delivery contract envelope",
      "inputCategory": "lunar-delivery-cost",
      "currentUse": "Constrains lunar delivery analogy context only; not a direct Moon factory logistics quote.",
      "dataState": "source-linked-partial-program-context",
      "sourceDate": "2026-06-20",
      "unitsRequired": [
        "USD",
        "task order",
        "payload",
        "provider",
        "period"
      ],
      "requiredNormalization": [
        "Resolve task-order awards and modifications from NASA/USAspending.",
        "Separate payload integration, launch, landing, mission operations, and provider-specific scope.",
        "Avoid applying the total CLPS envelope as a per-mission cost."
      ],
      "modelInputRefs": [
        "scenarioBusinessCase.destinationDifficulty",
        "inputDistributions.ranges.launchMassT"
      ],
      "sourceRefs": [
        {
          "sourceId": "nasa-clps",
          "title": "Commercial Lunar Payload Services",
          "trust": "primary",
          "sourceType": "commercial-lunar-delivery-program",
          "recordHash": "fnv1a32-7d151be6",
          "url": "https://www.nasa.gov/commercial-lunar-payload-services/",
          "queryPolicy": "Capture NASA program page, date, task-order references, provider, payload mass/context, and award amount where available.",
          "uncertaintyMode": "Task-order scope, modifications, mission risk, provider performance, and payload-specific services."
        },
        {
          "sourceId": "usaspending",
          "title": "USAspending.gov",
          "trust": "primary",
          "sourceType": "federal-award-database",
          "recordHash": "fnv1a32-fb43b155",
          "url": "https://www.usaspending.gov/",
          "queryPolicy": "Preserve query filters, award id, recipient, agency, obligation amounts, date range, and retrieval hash.",
          "uncertaintyMode": "Award modification timing, obligation versus outlay, scope classification, and recipient hierarchy."
        }
      ],
      "missingSourceIds": [],
      "evidenceScore": 66,
      "promotionGate": {
        "promotionAllowed": false,
        "state": "blocked-for-commercial-economics",
        "blockers": [
          "Source data is not normalized into model-ready numeric inputs.",
          "No calibrated capex/opex/market model artifact is attached.",
          "Economics source record is not yet allowed to promote price, ROI, demand, or investment claims."
        ],
        "allowedUse": "May be used only as a source-backed planning boundary, not as a commercial economics claim."
      },
      "evidenceHash": "sha256-cd8dcde2d818fc3b2eed2614a7e0c7d54dd222d3073ac13a9074d394a7473dd7"
    },
    {
      "id": "capex-estimating-method",
      "label": "Capex estimating method",
      "inputCategory": "capex",
      "currentUse": "Documents method expectations; current capex numbers remain planning heuristics.",
      "dataState": "method-source-linked-no-parametric-calibration",
      "sourceDate": "2026-06-20",
      "unitsRequired": [
        "USD",
        "year basis",
        "risk reserve",
        "schedule",
        "maturity"
      ],
      "requiredNormalization": [
        "Select estimating class and analogy/parametric method.",
        "Attach normalization year and inflation/escalation rule.",
        "Tie maturity, schedule, and risk reserves to scenario-specific work breakdown structure."
      ],
      "modelInputRefs": [
        "scenarioBusinessCase.developmentCapexBn",
        "scenario.risks.processMaturity"
      ],
      "sourceRefs": [
        {
          "sourceId": "nasa-cost-estimating-handbook",
          "title": "NASA Cost Estimating Handbook",
          "trust": "primary",
          "sourceType": "cost-estimating-methodology",
          "recordHash": "fnv1a32-a82e1046",
          "url": "https://www.nasa.gov/reference/nasa-cost-estimating-handbook/",
          "queryPolicy": "Document handbook version, estimating method, normalization year, risk treatment, and applied model assumptions.",
          "uncertaintyMode": "Method selection, analogy quality, learning curves, schedule risk, and normalization assumptions."
        },
        {
          "sourceId": "nasa-se-handbook",
          "title": "NASA Systems Engineering Handbook",
          "trust": "primary",
          "sourceType": "systems-engineering-methodology",
          "recordHash": "fnv1a32-991637e4",
          "url": "https://www.nasa.gov/reference/systems-engineering-handbook/",
          "queryPolicy": "Document handbook version, review/maturity concept used, and mapping to scenario/process gates.",
          "uncertaintyMode": "Program-specific tailoring and maturity-assessment subjectivity."
        }
      ],
      "missingSourceIds": [],
      "evidenceScore": 66,
      "promotionGate": {
        "promotionAllowed": false,
        "state": "blocked-for-commercial-economics",
        "blockers": [
          "Source data is not normalized into model-ready numeric inputs.",
          "No calibrated capex/opex/market model artifact is attached.",
          "Economics source record is not yet allowed to promote price, ROI, demand, or investment claims."
        ],
        "allowedUse": "May be used only as a source-backed planning boundary, not as a commercial economics claim."
      },
      "evidenceHash": "sha256-201b078539f5927b396f839f3cd93f36e23e12487af804803f06a2a7204d0bdc"
    },
    {
      "id": "opex-and-operations-reserve-method",
      "label": "Opex and operations reserve method",
      "inputCategory": "opex",
      "currentUse": "Documents reserve drivers; current operations reserve remains a heuristic.",
      "dataState": "method-source-linked-no-mission-calibration",
      "sourceDate": "2026-06-20",
      "unitsRequired": [
        "USD/year",
        "staffing",
        "comms operations",
        "autonomy",
        "maintenance"
      ],
      "requiredNormalization": [
        "Define operations concept and communication architecture.",
        "Separate ground operations, autonomy software, maintenance, spares, and review cadence.",
        "Calibrate reserves against comparable mission/program records where legally available."
      ],
      "modelInputRefs": [
        "scenarioBusinessCase.operationsReserveBn",
        "scenario.risks.comms"
      ],
      "sourceRefs": [
        {
          "sourceId": "nasa-cost-estimating-handbook",
          "title": "NASA Cost Estimating Handbook",
          "trust": "primary",
          "sourceType": "cost-estimating-methodology",
          "recordHash": "fnv1a32-a82e1046",
          "url": "https://www.nasa.gov/reference/nasa-cost-estimating-handbook/",
          "queryPolicy": "Document handbook version, estimating method, normalization year, risk treatment, and applied model assumptions.",
          "uncertaintyMode": "Method selection, analogy quality, learning curves, schedule risk, and normalization assumptions."
        },
        {
          "sourceId": "nasa-dtn",
          "title": "Delay/Disruption Tolerant Networking",
          "trust": "primary",
          "sourceType": "communications-program-reference",
          "recordHash": "fnv1a32-61e03fe6",
          "url": "https://www.nasa.gov/communicating-with-missions/delay-disruption-tolerant-networking/",
          "queryPolicy": "Program reference, architecture assumption, and scenario mapping required.",
          "uncertaintyMode": "Conceptual architecture until mission-specific link data exists."
        },
        {
          "sourceId": "ccsds",
          "title": "Consultative Committee for Space Data Systems",
          "trust": "primary",
          "sourceType": "space-data-standard",
          "recordHash": "fnv1a32-75fdfe19",
          "url": "https://ccsds.org/",
          "queryPolicy": "Publication id, version, area, and applied assumption required.",
          "uncertaintyMode": "Standards conformance caveats and mission-specific implementation deltas."
        }
      ],
      "missingSourceIds": [],
      "evidenceScore": 66,
      "promotionGate": {
        "promotionAllowed": false,
        "state": "blocked-for-commercial-economics",
        "blockers": [
          "Source data is not normalized into model-ready numeric inputs.",
          "No calibrated capex/opex/market model artifact is attached.",
          "Economics source record is not yet allowed to promote price, ROI, demand, or investment claims."
        ],
        "allowedUse": "May be used only as a source-backed planning boundary, not as a commercial economics claim."
      },
      "evidenceHash": "sha256-1717c7cfc8352054c975089aba9237837c363a0ca69235f9e640c6644e583acc"
    },
    {
      "id": "market-and-company-financial-context",
      "label": "Market and company financial context",
      "inputCategory": "market",
      "currentUse": "Backlog for customer/market due diligence; not used for revenue claims.",
      "dataState": "source-surface-linked-no-demand-model",
      "sourceDate": "2026-06-20",
      "unitsRequired": [
        "USD",
        "filing period",
        "award obligations",
        "market segment"
      ],
      "requiredNormalization": [
        "Attach company filings and award records by CIK, accession, award id, and date.",
        "Separate revenue, backlog, capex, R&D, and risk-factor text.",
        "Do not infer demand from social or forum signals without primary-source bridge."
      ],
      "modelInputRefs": [
        "economicsFrontier.promotionBlockers",
        "researchPackages.buyerFit"
      ],
      "sourceRefs": [
        {
          "sourceId": "sec-edgar",
          "title": "SEC EDGAR",
          "trust": "primary",
          "sourceType": "public-company-filings",
          "recordHash": "fnv1a32-f2e84204",
          "url": "https://www.sec.gov/edgar",
          "queryPolicy": "Preserve CIK/ticker, accession number, filing date, statement section, XBRL fields, and retrieval hash.",
          "uncertaintyMode": "Company-specific accounting policy, segment allocation, forward-looking statements, and market-cycle caveats."
        },
        {
          "sourceId": "usaspending",
          "title": "USAspending.gov",
          "trust": "primary",
          "sourceType": "federal-award-database",
          "recordHash": "fnv1a32-fb43b155",
          "url": "https://www.usaspending.gov/",
          "queryPolicy": "Preserve query filters, award id, recipient, agency, obligation amounts, date range, and retrieval hash.",
          "uncertaintyMode": "Award modification timing, obligation versus outlay, scope classification, and recipient hierarchy."
        }
      ],
      "missingSourceIds": [],
      "evidenceScore": 66,
      "promotionGate": {
        "promotionAllowed": false,
        "state": "blocked-for-commercial-economics",
        "blockers": [
          "Source data is not normalized into model-ready numeric inputs.",
          "No calibrated capex/opex/market model artifact is attached.",
          "Economics source record is not yet allowed to promote price, ROI, demand, or investment claims."
        ],
        "allowedUse": "May be used only as a source-backed planning boundary, not as a commercial economics claim."
      },
      "evidenceHash": "sha256-228cb6a20a2fca0ac790d144a2ca2706132057aa5ffdba4d96a88c16176898af"
    }
  ],
  "ledgerHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297"
}
;
